import {
  DEFAULT_QR_QUALITY,
  DEFAULT_QR_BORDER,
  DEFAULT_QR_SCALE,
  COLOR_BLACK,
  COLOR_WHITE,
  DEFAULT_ZLIB_COMPRESSION_LEVEL,
  DEFAULT_ECC_LEVEL,
  ZIP_HEADER,
  DEFAULT_ZIP_FILE_NAME,
  CLAIM_169_MAP,
} from '../shared/Constants';

// Debug: Check webpack public path before loading chunks
if (typeof window !== 'undefined') {
  const publicPath = (window as any).__webpack_public_path__;
  console.log('[generateQRCode] Webpack public path before imports:', publicPath);
  if (!publicPath || publicPath === '/') {
    console.warn('[generateQRCode] WARNING: Webpack public path is not set correctly!');
    console.warn('[generateQRCode] Attempting to set from window.env...');
    const basePath = (window as any).env?.REACT_APP_BASE_PATH || '';
    if (basePath) {
      const normalized = basePath.startsWith('/') ? basePath : `/${basePath}`;
      const newPublicPath = normalized + '/';
      (window as any).__webpack_public_path__ = newPublicPath;
      if (typeof globalThis !== 'undefined') {
        (globalThis as any).__webpack_public_path__ = newPublicPath;
      }
      console.log('[generateQRCode] Set webpack public path to:', newPublicPath);
    }
  }
}

let qrcode: any;

(async () => {
  console.log('[generateQRCode] Starting dynamic import of qrcode...');
  console.log('[generateQRCode] Current webpack public path:', (window as any).__webpack_public_path__);
  try {
    qrcode = await import('qrcode');
    console.log('[generateQRCode] qrcode module loaded successfully:', qrcode);
  } catch (error) {
    console.error('[generateQRCode] Error loading qrcode:', error);
    throw error;
  }
})();

let cbor: any;

(async () => {
  console.log('[generateQRCode] Starting dynamic import of cbor-web...');
  console.log('[generateQRCode] Current webpack public path:', (window as any).__webpack_public_path__);
  try {
    cbor = await import('cbor-web');
    console.log('[generateQRCode] CBOR module loaded successfully:', cbor);
  } catch (error) {
    console.error('[generateQRCode] Error loading cbor-web:', error);
    throw error;
  }
})();

let pako: any;

(async () => {
  console.log('[generateQRCode] Starting dynamic import of pako...');
  console.log('[generateQRCode] Current webpack public path:', (window as any).__webpack_public_path__);
  try {
    pako = await import('pako');
    console.log('[generateQRCode] pako module loaded successfully:', pako);
  } catch (error) {
    console.error('[generateQRCode] Error loading pako:', error);
    throw error;
  }
})();

let b45: any;

(async () => {
  console.log('[generateQRCode] Starting dynamic import of base45-web...');
  console.log('[generateQRCode] Current webpack public path:', (window as any).__webpack_public_path__);
  try {
    b45 = await import('base45-web');
    console.log('[generateQRCode] base45-web module loaded successfully:', b45);
  } catch (error) {
    console.error('[generateQRCode] Error loading base45-web:', error);
    throw error;
  }
})();


function hexStringToArrayBuffer(hexString:string): ArrayBuffer {
hexString = hexString.replace(/^0x/, '');
if (hexString.length % 2 != 0) {
    console.log('WARNING: expecting an even number of characters in the hexString');
}
var bad = hexString.match(/[G-Z\s]/i);
if (bad) {
    console.log('WARNING: found non-hex characters', bad);
}
var pairs = hexString.match(/[\dA-F]{2}/gi);
var integers = pairs ? pairs.map(function(s) {
    return parseInt(s, 16);
}) : [];
var array = new Uint8Array(integers);
console.log(array);
return array.buffer;
}

async function generateQRData(data: any, header = "") {
let parsedData = null;
let compressedData, b45EncodedData,cborString;
try {
    cborString = await cbor.diagnose(data);
    parsedData = JSON.parse(data);
    const cborEncodedData = cbor.encode(parsedData);
    compressedData = pako.deflate(cborEncodedData, {level: DEFAULT_ZLIB_COMPRESSION_LEVEL});
} catch (e) {
    console.error("Data is not JSON");
    compressedData = pako.deflate(data, {level: DEFAULT_ZLIB_COMPRESSION_LEVEL});
} finally {
    b45EncodedData = b45.encode(compressedData).toString();
}

return [cborString,header + b45EncodedData];
}

const generateQRCode = async (cwt: string): Promise<string[]> => {
  try {
    const opts = {
      errorCorrectionLevel: DEFAULT_ECC_LEVEL,
      quality: DEFAULT_QR_QUALITY,
      margin: DEFAULT_QR_BORDER,
      scale: DEFAULT_QR_SCALE,
      color: {
          dark: COLOR_BLACK,
          light: COLOR_WHITE
      }
  }

  // Ensure cbor is loaded dynamically
  if (!cbor) {
      cbor = await import('cbor-web');
  }

  // Ensure cbor is loaded dynamically
  if (!qrcode) {
    qrcode = await import('qrcode');
  }

  // Ensure cbor is loaded dynamically
  if (!pako) {
    pako = await import('pako');
  }

  let qrData = await generateQRData(hexStringToArrayBuffer(cwt));
  let version = qrcode.create(qrData[1], {errorCorrectionLevel : DEFAULT_ECC_LEVEL}).version
  let qr = await qrcode.toDataURL(qrData[1],opts)
  return [version,qrData[1].length,qr,qrData[0].toString().replaceAll(`h'`,`\nh'`)]

  } catch (error) {
      console.error('Error in Generating QR code:', error);
      throw new Error('Error in Generating QR code');
  }
};

export default generateQRCode;